exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!../../../../../assets/benchCss/base.scss"), "");

// module
exports.push([module.id, ".topTab[data-v-db1ad61a] {\n  padding-bottom: 20px;\n}\n.roomStatusName[data-v-db1ad61a] {\n  font-weight: 600;\n}\n.isSOS[data-v-db1ad61a] {\n  color: #ff4d4d;\n}\n.isQingLi[data-v-db1ad61a] {\n  color: #409eff;\n}\n.isMenCi[data-v-db1ad61a] {\n  color: #e6a23c;\n}\n", ""]);

// exports
